<script>
export default {
  props: {
    objectOfExpenditures: null,
    oeTableBusy: null,
    selectedFS: null,
  },
  data() {
    return {
      fields: [
        // {
        //   key: "uacs",
        //   label: "UACS",
        // },
        // {
        //   key: "account.accountName",
        //   label: "Account name",
        // },
        {
          key: "accountGroup.groupName",
          label: "Account",
        },
        {
          key: "allocation",
          label: "Allocation",
          tdClass: "text-info text-end",
          thClass: "text-end",
        },
        {
          key: "balance",
          label: "Balance",
          tdClass: "text-end",
          thClass: "text-end",
        },
        {
          key: "actions",
          label: "Actions",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: ["accountGroup.groupName"],
      sortBy: "account",
      sortDesc: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkExpiry(data) {
      return new Date() < new Date(data) ? true : false;
    },
    formatCurrency(data) {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "PHP",
      }).format(data);
    },
    viewTransactions(row) {
      this.$emit("viewTransactions", row);
    },
    deleteItem(row) {
      // if (row.item.objectOfExpenditureTransactions.length > 0) {
      //   return this.showToast("Cannot delete item with existing transactions", "error");
      // } else {
        this.$emit("deleteItem", row);
      // }
    },
    print(id) {
      this.$emit("print", id);
    },
  },
  computed: {
    rows() {
      let data = this.objectOfExpenditures;
      if (this.filter) {
        return this.totalRows;
      }
      return data.length;
    },
  },
};
</script>

<template>
  <div>
    <div class="row mb-2">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_filter" class="dataTables_filter">
          <label class="d-inline-flex align-items-center">
            <b-form-input 
              v-model="filter"
              type="search"
              placeholder="Search account name..."
              class="form-control me-1"></b-form-input>
              <b-form-select 
                style="width: 90px;"
                class="form-select"
                v-model="perPage"
                size="sm"
                :options="pageOptions">
              </b-form-select>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 text-right">
        <button type="button" class="btn btn-primary" @click="$emit('add-new')"><i class="bx bx-plus"></i> Add New OOE</button>
      </div>
    </div>
    <div class="custom-table-responsive mb-0">
      <b-table 
        :items="objectOfExpenditures"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :busy="oeTableBusy"
        @filtered="onFiltered"
        bordered
        outlined
        striped
        show-empty
        selected-variant="success"
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(uacs)="row">
          <span class="badge rounded-pill badge-soft-info">{{
            row.item.account ? row.item.account.uacs : "-"
          }}</span>
        </template>
        <template #cell(balance)="row">
          <span class="text-danger"
                v-if="row.item.balance < 0">({{ formatCurrency(row.item.balance) }})</span>
          <span class="text-warning"
                v-else>{{
                  row.item.balance ? formatCurrency(row.item.balance) : formatCurrency(0)
                }}</span>
        </template>
        <template #cell(allocation)="row">
          {{
            row.item.allocation ? formatCurrency(row.item.allocation) : formatCurrency(0)
          }}
        </template>
        <template #cell(actions)="row">
          <b-button variant="link"
                    size="sm"
                    :id="`popover-target-${row.item.id}`">
            <i class="fas fa-ellipsis-h"></i>
          </b-button>
          <b-popover :target="`popover-target-${row.item.id}`"
                     id="menu"
                     triggers="hover blur"
                     placement="leftbottom"
                     variant="secondary"
                     custom-class="p-0 p-custom-class">
            <b-list-group class="w-100 fit">
              <b-list-group-item button
                                 action
                                 @click="viewTransactions(row)">
                <i class="mdi mdi-format-list-checks align-middle me-2 font-size-16 text-warning"></i>
                <span class="align-middle">View Transactions</span>
              </b-list-group-item>
              <b-list-group-item button
                                 action
                                 @click="print(row.item.id)">
                <i class="bx bx-printer align-middle me-2 font-size-16 text-info"></i><span class="align-middle">Print
                  RAOS</span>
              </b-list-group-item>
              <b-list-group-item button
                                 action
                                 @click="deleteItem(row)">
                <i class="mdi mdi-trash-can align-middle me-2 font-size-16 text-danger"></i><span
                      class="align-middle">Delete</span>
              </b-list-group-item>
            </b-list-group>
          </b-popover>
        </template>
      </b-table>
    </div>
    <div class="row mb-3">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-sm mb-0">
            <!-- pagination -->
            <b-pagination 
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage">
            </b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.p-custom-class .popover-body {
  padding: 0 !important;
  border: 0 !important;
}

.p-custom-class .list-group-item {
  border: 0 !important;
}
</style>
